// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"108":"8d9913f6","139":"2205fe0e","149":"b35154b0","184":"852a67de","334":"4ca508ef","383":"e9f100e7","455":"2db74818","474":"aad544ee","787":"55493f23","909":"27ea0b75","923":"64681f9c","924":"6014e7de"}[chunkId] + ".chunk.js";
};